export const defaultGlobalFont = ({ globalFontId, accountFonts }) => {
  if (!globalFontId || globalFontId === '0') return 'inherit';
  const fontId = globalFontId.split('-')[0];
  if (!accountFonts[fontId]) return 'inherit';
  return `${accountFonts[fontId].name}, ${accountFonts[fontId].fallback || 'sans-serif'}`;
};
